export default __webpack_public_path__ + "static/media/shivada_jade_fragment.a6566232.png";